<template lang="pug">
  section.section-6.find-job.home-jobs
    .block-wrap
      .section-6-wrap
        .headline
          span  {{ gettext('Agricultural traineeship positions') }}
        .tile.is-parent.is-9.main-block(v-if="(offers.items || []).length")
          .content.vacancy-wrap
            vacancy-preview(v-for="(offer, index) in offers.items" :offer="offer" :allCategories="allCategories" :key="index")
        .headline(v-else)
          span  {{ gettext('No positions yet') }}
        .tile.is-2.see-all(v-if="(offers.items || []).length")
          router-link.main-btn.col-white.bg-black(:to="{name: 'FindJob', params:{lang: getLanguage}, query: {emt: 1, ct: 1}}")
            span(@click="showNav = false") {{ gettext('See all') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { gettext } from '../../../../services/TranslateHandler'
import VacancyPreview from '../../../search/find-job/parts/vacancy-preview'

const _ = require('lodash')

export default {
  name: 'jobs',
  data () {
    return {
      offers: {},
      allCategories: []
    }
  },
  components: {
    VacancyPreview
  },
  methods: {
    ...mapActions(['searchVacancy', 'receiveCompanyTypes']),
    gettext: gettext,
    getAllCategories () {
      this.receiveCompanyTypes({lang: this.getLanguage, country: null}).then(res => {
        this.allCategories = _.sortBy(res, ['id'])
      })
    },
    search () {
      this.getAllCategories()
      this.searchVacancy({
        lang: this.getLanguage,
        q: '',
        page: 1,
        size: 4,
        order: 'updated',
        filters: {
          employment_types: [1],
          company_type: 1
        }
      }).then(res => {
        this.offers = res
      })
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    getLanguage () {
      this.search()
    }
  },
  created () {
    this.search()
  }
}
</script>

<style lang="scss" src="../../../search/find-job/styles.scss"></style>
<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/agricultural-trainee/parts/jobs/index.vue